import { Routes } from '@angular/router';
import { Dashboard } from './components/dashboard/dashboard';
import { Disbursement } from './components/disbursement/disbursement';
import { LeadDashboard } from './components/leads/lead-dashboard/lead-dashboard';
import { AddNewLead } from './components/leads/add-new-lead/add-new-lead';
import { Demographic } from './components/leads/demographic/demographic';
import { AddTerms } from './components/leads/add-terms/add-terms';
import { Onboard } from './components/onboarding/onboard/onboard';
import { Corporate } from './components/onboarding/corporate/corporate';
import { RiskFatca } from './components/onboarding/risk-fatca/risk-fatca';
import { Ubos } from './components/onboarding/ubos/ubos';
import { Directors } from './components/onboarding/directors/directors';
import { KeyManagement } from './components/onboarding/key-management/key-management';
import { CommitteeMembers } from './components/onboarding/committee-members/committee-members';
import { Documents } from './components/onboarding/documents/documents';
import { ClientList } from './components/onboarding/client-list/client-list';
import { Kibor } from './components/setup/kibor/kibor';
import { Client } from './components/client/client';
import { CommonCodes } from './components/setup/common-codes/common-codes';
import { ReferenceGroupValues } from './components/setup/common-codes/reference-group-values/reference-group-values';
import { GuarantorSetup } from './components/setup/guarantor-setup/guarantor-setup';
import { GuarantorClientList } from './components/setup/guarantor-setup/guarantor-client-list/guarantor-client-list';
import { UsdRateList } from './components/setup/usd-rate-list/usd-rate-list';
import { CurrencyRate } from './components/setup/usd-rate-list/currency-rate/currency-rate';
import { AuthGuard } from './core/guards/auth.guard';
import { documentBuilderUnsavedChangesGuard } from './core/guards/document-builder-unsaved-changes.guard';
import { MainLayout } from './core/layout/main-layout/main-layout';
import { KiborPartial } from './components/setup/kibor/kibor-partial/kibor-partial';
import { KiborQuarterly } from './components/setup/kibor/kibor-quarterly/kibor-quarterly';

import { ClientGlCode } from './components/GL/client-gl-code/client-gl-code';
import { PaymentTypesComponent } from './components/GL/payment-type/payment-type';
import { RemittanceType } from './components/GL/remittance-type/remittance-type';
import { generate } from 'rxjs';
import { GeneralVoucher } from './components/admin/general-voucher/general-voucher';
import { DocumentHistory } from './components/leads/document-history/document-history';
import { City } from './components/setup/city/city';
import { Geography } from './components/setup/geography/geography';
import { State } from './components/setup/geography/state/state';
import { District } from './components/setup/geography/district/district';
import { Tehsil } from './components/setup/geography/tehsil/tehsil';
import { Questionnaire } from './components/questionnaire/questionnaire';
import { QuestionSetup } from './components/questionnaire/question-setup/question-setup';
import { AnswerSetup } from './components/questionnaire/answer-setup/answer-setup';
import { LeadDocuments } from './components/leads/lead-documents/lead-documents';
import { ReportsDashboard } from './components/reports/reports';
import { DisbursementReportComponent } from './components/reports/disbursement-report/disbursement-report';
import { RepaymentReportComponent } from './components/reports/repayment-report/repayment-report';
import { QprReportComponent } from './components/reports/qpr-report/qpr-report';
import { QprListingComponent } from './components/reports/qpr-listing/qpr-listing';
import { MprReportComponent } from './components/reports/mpr-report/mpr-report';
import { MprListingComponent } from './components/reports/mpr-listing/mpr-listing';
import { ExposureReportComponent } from './components/reports/exposure-report/exposure-report';
import { ApprvdFacilitiesRprtComponent } from './components/reports/apprvd-facilities-rprt/apprvd-facilities-rprt';
import { ProjectionReportComponent } from './components/reports/projection-report/projection-report';
import { EnhncdApprvdFacilitiesRprtComponent } from './components/reports/enhncd-apprvd-facilities-rprt/enhncd-apprvd-facilities-rprt';
import { CnsldtdQprRprtComponent } from './components/reports/cnsldtd-qpr-rprt/cnsldtd-qpr-rprt';
import { PbCnsldtdQprRprtComponent } from './components/reports/pb-cnsldtd-qpr-rprt/pb-cnsldtd-qpr-rprt';
import { CnsldtdMprRprtComponent } from './components/reports/cnsldtd-mpr-rprt/cnsldtd-mpr-rprt';
import { Review } from './components/onboarding/review/review';
import { DocmentsSetup } from './components/setup/documents-module/docments-setup/docments-setup';
import { DocumentTypes } from './components/setup/documents-module/document-types/document-types';
import { RoleAssignment } from './components/setup/role-assignment/role-assignment';
import { Notifications } from './components/shared/notifications/notifications';
import { Terms } from './components/credit/terms/terms';
import { AddDemographic } from './components/credit/add-demographic/add-demographic';
import { AddFacilites } from './components/credit/add-facilites/add-facilites';
import { CraditPerposel } from './components/credit/cradit-perposel/cradit-perposel';
import { DisbursementRepayment } from './components/credit/disbursement-repayment/disbursement-repayment';
import { DocumentList } from './components/credit/document-list/document-list';
import { FacilitesList } from './components/credit/facilites-list/facilites-list';
import { FoLtrDocs } from './components/credit/fo-ltr-docs/fo-ltr-docs';
import { FinancialData } from './components/credit/financial-data/financial-data';
import { QualitativeAssessment } from './components/credit/qualitative-assessment/qualitative-assessment';
import { CraditList } from './components/credit/cradit-list/cradit-list';
import { CompnayProfile } from './components/credit/compnay-profile/compnay-profile';
import { KeyRiskResponses } from './components/credit/key-risk-responses/key-risk-responses';
import { InstitutionalRating } from './components/credit/institutional-rating/institutional-rating';
import { DocumentBuilderPage } from '../features/document-builder/pages/document-builder-page/document-builder-page';
import { FinancialDataSetup } from './components/setup/financial-data-setup/financial-data-setup';
import { FinancialDataValue } from './components/setup/financial-data-setup/financial-data-value/financial-data-value';
import { GenrateCreditReport } from './components/credit/genrate-credit-report/genrate-credit-report';
import { IncomType } from './components/setup/incmstate-mngmnt/incom-type/incom-type';
import { IncomValue } from './components/setup/incmstate-mngmnt/incom-value/incom-value';
import { ProposedDisbursementList } from './components/credit/proposed-disbursement-list/proposed-disbursement-list';
import { DisbursementNote } from './components/credit/disbursement-note/disbursement-note';
import { MonitoringList } from './components/monitoring/monitoring-list/monitoring-list';
import { MonitoringDetail } from './components/monitoring/monitoring-detail/monitoring-detail';
import { DepartmentHead } from './components/setup/organization/department-head/department-head';
import { TeamLead } from './components/setup/organization/team-lead/team-lead';
import { RelationalOfficer } from './components/setup/organization/relational-officer/relational-officer';
import { EmployeeRegistration } from './components/setup/employee-registration/employee-registration';
import { CnicExpiry } from './components/cnic-expiry/cnic-expiry';

export const routes: Routes = [
  // default route
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // SECURED APP LAYOUT
  {
    path: '',
    component: MainLayout,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: Dashboard },
      { path: 'client', component: Client },
      { path: 'disbursement', component: Disbursement },
      { path: 'leads', component: LeadDashboard },

      // add new leads with child routes
      {
        path: 'add-new-leads',
        component: AddNewLead,
        children: [
          { path: '', redirectTo: 'demographic', pathMatch: 'full' },
          { path: 'demographic', component: Demographic },
          { path: 'demographic/:id', component: Demographic },
          { path: 'document/:id', component: LeadDocuments },
          { path: 'add-terms/:id', component: AddTerms },
          { path: 'summary/:id', component: Terms },
        ],
      },
      { path: 'document-history/:id', component: DocumentHistory },
      // onboarding
      { path: 'client-list', component: Client },
      { path: 'onboard', component: ClientList },
      // Credit Proposal Uploader was merged into Credit List; keep old links working.
      { path: 'upload-cradit-perposal', redirectTo: 'cradit-list', pathMatch: 'full' },
      {
        path: 'onboarding',
        component: Onboard,
        children: [
          { path: '', redirectTo: 'corporate', pathMatch: 'full' },
          { path: 'corporate/:id', component: Corporate },
          { path: 'risk-fatca/:id', component: RiskFatca },
          { path: 'ubos/:id', component: Ubos },
          { path: 'directors/:id', component: Directors },
          { path: 'key-management/:id', component: KeyManagement },
          { path: 'committee-members/:id', component: CommitteeMembers },
          { path: 'documents/:id', component: Documents },
          { path: 'review-details/:id', component: Review },
        ],
      },
      { path: 'notifications', component: Notifications },
      {
        path: 'facilites',
        component: FacilitesList,
      },
      {
        path: 'facility-offer-letter-documents/:id',
        component: FoLtrDocs,
      },
      { path: 'cradit-list', component: CraditList },
      { path: 'proposed-disbursement', component: ProposedDisbursementList },
      {
        path: 'disbursement-note/:prpsdDsbmntSeq',
        component: DisbursementNote,
      },
      { path: 'report-cradit-perposal/:id', component: GenrateCreditReport },

      // monitoring
      { path: 'monitoring', component: MonitoringList },
      { path: 'monitoring/:clntSeq', component: MonitoringDetail },
      
      //    {
      //   path: 'new-credit/:oid',
      //   component: AddFacilites,
      //   children: [
      //     { path: '', redirectTo: 'demographic', pathMatch: 'full' },
      //     { path: 'demographic', component: AddDemographic },
      //     { path: 'financial-data', component: FinancialData },
      //     { path: 'key-risk-responses', component: KeyRiskResponses },
      //     { path: 'qualitative', component: QualitativeAssessment },
      //     { path: 'credit-proposal', component: CraditPerposel },
      //     { path: 'document', component: DocumentList },
      //     { path: 'terms', component: Terms },
      //     { path: 'disbursement', component: DisbursementRepayment },
      //     { path: 'company-profile', component: CompnayProfile },
      //     { path: 'highlights', component: HightlightCredit },
      //     { path: 'institutional-rating', component: InstitutionalRating },
      //   ]
      // },

      {
        path: 'document-builder/:id',
        component: DocumentBuilderPage,
        canDeactivate: [documentBuilderUnsavedChangesGuard],
      },
      { path: 'general-voucher', component: GeneralVoucher },
      { path: 'common-codes', component: CommonCodes },
      { path: 'common-code-values', component: ReferenceGroupValues },
      { path: 'guarantor-setup', component: GuarantorSetup },
      { path: 'guarantor-client-list', component: GuarantorClientList },
      { path: 'usd-rate-list', component: UsdRateList },
      { path: 'currency-rate', component: CurrencyRate },
      {
        path: 'kibor',
        component: Kibor,
        children: [
          {
            path: '',
            redirectTo: 'partial',
            pathMatch: 'full',
          },
          {
            path: 'partial',
            component: KiborPartial,
          },
          {
            path: 'quarterly',
            component: KiborQuarterly,
          },
        ],
      },
      { path: 'city', component: City },
      { path: 'payment-type', component: PaymentTypesComponent },
      { path: 'client-gl-code', component: ClientGlCode },
      { path: 'remittance-type', component: RemittanceType },
      { path: 'department-head', component: DepartmentHead },
      { path: 'team-lead/:id', component: TeamLead },
      { path: 'relational-officer/:id', component: RelationalOfficer },
      { path: 'employee-registration', component: EmployeeRegistration },
      { path: 'cnic-expiry', component: CnicExpiry },
      { path: 'geography', component: Geography },
      { path: 'state/:id', component: State },
      {
        path: 'tehsil/:id',
        component: Tehsil,
      },
      {
        path: 'district/:id',
        component: District,
      },
      { path: 'financial', component: FinancialDataSetup },
      {
        path: 'financial-data-value/:id',
        component: FinancialDataValue,
      },

      { path: 'financial-data', component: FinancialData },
      { path: 'income-statement-type', component: IncomType },
      {
        path: 'income-statement-value/:stmntTypSeq',
        component: IncomValue,
      },

      { path: 'questioner', component: Questionnaire },
      { path: 'questions/:id', component: QuestionSetup },
      {
        path: 'answers/:id',
        component: AnswerSetup,
      },
      { path: 'document-setup', component: DocmentsSetup },
      { path: 'document-types/:id', component: DocumentTypes },
      { path: 'user-management', component: RoleAssignment },
      {
        path: 'reports',
        component: ReportsDashboard,
        children: [
          { path: '', redirectTo: 'disbursement', pathMatch: 'full' },
          { path: 'disbursement', component: DisbursementReportComponent },
          { path: 'repayment', component: RepaymentReportComponent },
          { path: 'qpr', component: QprReportComponent },
          { path: 'qpr-listing', component: QprListingComponent },
          { path: 'mpr', component: MprReportComponent },
          { path: 'mpr-listing', component: MprListingComponent },
          { path: 'exposure', component: ExposureReportComponent },
          { path: 'approved-facilities', component: ApprvdFacilitiesRprtComponent },
          { path: 'projection', component: ProjectionReportComponent },
          { path: 'enhanced-approved-facilities', component: EnhncdApprvdFacilitiesRprtComponent },
          { path: 'consolidated-qpr', component: CnsldtdQprRprtComponent },
          { path: 'pb-consolidated-qpr', component: PbCnsldtdQprRprtComponent },
          { path: 'consolidated-mpr', component: CnsldtdMprRprtComponent },
        ],
      },
    ],
  },
  // fallback (optional but recommended)
  { path: '**', redirectTo: 'dashboard' },
];
